// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__vfXYM","description":"HomePage_description__kchKt","rightSide":"HomePage_rightSide__ldngd"};